// extracted by mini-css-extract-plugin
module.exports = {"banner":"m9t00"};